import React from "react";
// import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import type { JsPsych } from "jspsych";
import type { TubeConfig } from "./core/types";
import ColorSortApp from "./ColorSortApp";

export interface StartColorsortTrialParams {
  /** Initial array of tube configurations for this trial */
  initialTubes: TubeConfig[];
  /** Whether undo is allowed */
  undoEnabled: boolean;
  /** Whether reset is allowed */
  resetEnabled: boolean;
}

/**
 * Mounts the ColorSortApp into the given display element,
 * and hooks its onFinish callback to jsPsych.finishTrial.
 */
export function startColorsortTrial(
  display_element: HTMLElement,
  params: StartColorsortTrialParams,
  jsPsych: JsPsych
) {
  const { initialTubes, undoEnabled, resetEnabled } = params;

  /**
   * Called when the React app signals completion.
   * Finishes the jsPsych trial, returning the action log.
   */
  const onFinish = (data: { events: any[] }) => {
    jsPsych.finishTrial(data);
  };

  const root = createRoot(display_element);
  root.render(
    <ColorSortApp
      initialTubes={initialTubes}
      undoEnabled={undoEnabled}
      resetEnabled={resetEnabled}
      onFinish={onFinish}
    />
  );
}
